/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plugins_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixed_header_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixed_header_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fixed_header_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bread_menu_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bread_menu_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bread_menu_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__external_link_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__external_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__external_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__smartphone_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__smartphone_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__smartphone_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__google_analytics_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__google_analytics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__google_analytics_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kanamei_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kanamei_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__kanamei_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__topicpath_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__topicpath_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__topicpath_js__);









/***/ }),
/* 2 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// usage: log('inside coolFunc', this, arguments);
// paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function f() {
	log.history = log.history || [];log.history.push(arguments);if (this.console) {
		var args = arguments,
		    newarr;try {
			args.callee = f.caller;
		} catch (e) {};newarr = [].slice.call(args);if (_typeof(console.log) === 'object') log.apply.call(console.log, console, newarr);else console.log.apply(console, newarr);
	}
};

// make it safe to use console.log always
(function (a) {
	function b() {}for (var c = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","), d; !!(d = c.pop());) {
		a[d] = a[d] || b;
	}
})(function () {
	try {
		console.log();return window.console;
	} catch (a) {
		return window.console = {};
	}
}());

/*
 * jQuery Cookie Plugin v1.3.0
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function ($, document, undefined) {

	var pluses = /\+/g;

	function raw(s) {
		return s;
	}

	function decoded(s) {
		return unRfc2068(decodeURIComponent(s.replace(pluses, ' ')));
	}

	function unRfc2068(value) {
		if (value.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape
			value = value.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}
		return value;
	}

	var config = $.cookie = function (key, value, options) {

		// write
		if (value !== undefined) {
			options = $.extend({}, config.defaults, options);

			if (value === null) {
				options.expires = -1;
			}

			if (typeof options.expires === 'number') {
				var days = options.expires,
				    t = options.expires = new Date();
				t.setDate(t.getDate() + days);
			}

			value = config.json ? JSON.stringify(value) : String(value);

			return document.cookie = [encodeURIComponent(key), '=', config.raw ? value : encodeURIComponent(value), options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
			options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join('');
		}

		// read
		var decode = config.raw ? raw : decoded;
		var cookies = document.cookie.split('; ');
		var result = key ? null : {};
		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = decode(parts.join('='));

			if (config.json) {
				cookie = JSON.parse(cookie);
			}

			if (key && key === name) {
				result = cookie;
				break;
			}

			if (!key) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) !== null) {
			$.cookie(key, null, options);
			return true;
		}
		return false;
	};
})(jQuery, document);

// Anchor scrolling
;(function ($) {
	$.fn.scrollAnchors = function (options) {
		var settings = { duration: 500, easing: "swing" };
		if (options) $.extend(settings, options);
		return $(this).bind("click touchend", function (event) {
			event.preventDefault();
			var $target = $(this.hash);
			if (!$target.length) {
				$target = $("a[name=" + this.hash.slice(1) + "]");
			} // If the element has a name attribute only.
			var target_offset = $target.offset();
			var target_top = target_offset.top;
			$('html, body').stop().animate({ scrollTop: target_top }, settings.duration, settings.easing);
			window.location.hash = this.hash;
		});
	};
})(jQuery);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/* ヘッダ固定 */
var MENU_HEIGHT = $('#top-header').height(),
    DURATION = 500;

$('body').css('padding-top', MENU_HEIGHT);
$('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    $('body, html').animate({ scrollTop: target.offset().top - MENU_HEIGHT }, DURATION, 'swing');
});

/* アンカーへオフセットを追加してスクロール */
var url = $(location).attr('href');
if (url.indexOf("#") != -1) {
    var id = url.split("#");
    var $target = $('#' + id[id.length - 1]);
    if ($target.length) {
        $('body, html').animate({ scrollTop: $target.offset().top - MENU_HEIGHT }, DURATION, 'swing');
    }
}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
横幅960ピクセル未満で、パンくずリストを消してドロップダウンリストを
表示する
*/
function changeMenu() {
    $("#drop-menu").menu({ position: { my: 'left top', at: 'center top' } });
    if (window.innerWidth < 960) {
        $("#drop-menu").show();
        $("#breadcrumb").hide();
    } else {
        $("#drop-menu").hide();
        $("#breadcrumb").show();
    }
}
changeMenu();
$(window).bind('resize', {}, changeMenu);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/* 外部リンクへアイコンを追加 */
$('.external').each(function (i) {
    $('<a rel="noopener" target="_blank" title="別ウインドウで開きます" style="margin-left: 0.5em;"><img alt="アイコン:別ウインドウ" src="/common/img/external-link-orange-dark03-Shapes4FREE.png"></a>').attr('href', $(this).attr('href')).insertAfter($(this));
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/* スマートフォンに、PC用画面を表示させる */
$(function () {
    $(".switch_screen").hide();
    $('.pc_screen').hide();
    $('.sp_screen').hide();

    $(".pc_screen").click(function () {
        $.cookie("switch_screen", "pc", { path: '/' });
        url = location.href;
        location.href = url;
        return false;
    });

    $(".sp_screen").click(function () {
        $.cookie("switch_screen", "sp", { path: '/' });
        url = location.href;
        location.href = url;
        return false;
    });

    if (/iPhone|iPod|Android.*Mobile|Windows.*Phone/.test(navigator.userAgent)) {
        $(".switch_screen").show();
        if ($.cookie("switch_screen")) {
            mode = $.cookie("switch_screen");
        } else {
            mode = "sp";
        }
        if (mode == "pc") {
            $('meta[name="viewport"]').attr('content', 'width=1024');
            $('.sp_screen').show();
        } else {
            $('.pc_screen').show();
        }
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* Google Analytics */
(function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
ga('create', 'UA-266172-3', 'nic.ad.jp');
ga('send', 'pageview');

/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* カナメイ作成のscript類 */
jQuery(function ($) {

    /*---------------------------------------------------------------------------*/
    /* Font Size
    /*---------------------------------------------------------------------------*/
    ;(function () {
        // 初期表示はSSIで処理しています

        var $target = $("#main-container");
        var $chgFont = $(".change-fontsize");
        var fontSizeStr = $.cookie('font_size') || "large";

        $chgFont.find(".std").on("click", function () {
            changeFontSize(1, $(this), "std");
        }).end().find(".large").on("click", function () {
            changeFontSize(1.1, $(this), "large");
        }).end().find(".most-large").on("click", function () {
            changeFontSize(1.2, $(this), "most-large");
        });
        if (fontSizeStr === "std") {
            $chgFont.find(".std").addClass("active");
        } else {
            //cookieからセットする
            $chgFont.find("." + fontSizeStr).trigger("click");
        }

        function changeFontSize(size, el, sizeStr) {
            $target.css({ "font-size": size + "em" });
            $chgFont.find("span").removeClass("active");
            el.addClass("active");

            $.cookie('font_size', sizeStr, { expires: 30, path: '/' });
        }
    })();

    /*--------------------------------------------------------------------------*/
    /* menu
    /*--------------------------------------------------------------------------*/

    ;(function () {
        var $toggle = $('<span class="menu-toggle"></span>');
        $("#menu").children("ul").children("li").children("a").after($toggle);
    })();

    /*--------------------------------------------------------------------------*/
    /* FlexSlider
    /*--------------------------------------------------------------------------*/

    ;(function () {
        var $mainSlide = $('#main-slide');
        if (!$mainSlide.size()) return;

        var button_num = 4;

        $mainSlide.flexslider({
            //useCSS: false,
            animation: "fade", //Select your animation type (fade/slide)
            slideshow: true, //Should the slider animate automatically by default? (true/false)
            slideshowSpeed: 5000, //Set the speed of the slideshow cycling, in milliseconds
            animationDuration: 500, //Set the speed of animations, in milliseconds
            directionNav: true, //Create navigation for previous/next navigation? (true/false)
            controlNav: true, //Create navigation for paging control of each clide? (true/false)
            keyboardNav: true, //Allow for keyboard navigation using left/right keys (true/false)
            touchSwipe: true, //Touch swipe gestures for left/right slide navigation (true/false)
            prevText: "Previous", //Set the text for the "previous" directionNav item
            nextText: "Next", //Set the text for the "next" directionNav item
            randomize: false, //Randomize slide order on page load? (true/false)
            slideToStart: 0, //The slide that the slider should start on. Array notation (0 = first slide)
            pauseOnAction: true, //Pause the slideshow when interacting with control elements, highly recommended. (true/false)
            pauseOnHover: true, //Pause the slideshow when hovering over slider, then resume when no longer hovering (true/false)
            controlsContainer: ".flex-container", //Advanced property: Can declare which container the navigation elements should be appended too. Default container is the flexSlider element. Example use would be ".flexslider-container", "#container", etc. If the given element is not found, the default action will be taken.
            manualControls: ".flex-control-nav li", //Selector: Declare custom control navigation. Example would be ".flex-control-nav li" or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
            start: function start(slider) {
                var $ctrl_nav_ul = $(".flex-control-nav ul", slider).eq(0),
                    $li = $("li", $ctrl_nav_ul),
                    li_num = $li.size()
                //              , li_width = $li.css("width")
                ,
                    $ctrl_dir = $(".flex-control-nav-direction", $mainSlide),
                    navIndex = 0;

                if (!(li_num > button_num)) {
                    return;
                } else {
                    $ctrl_dir.show();
                }

                if (li_num > button_num) {
                    $li.css({ width: 100 / li_num - 0.5 + "%" });
                    $ctrl_nav_ul.css({ width: 100 / button_num * li_num + "%" });
                }

                $ctrl_dir.find(".next").on("click", function (e) {
                    e.preventDefault();
                    if (navIndex < slider.count - 1 && navIndex < slider.count - button_num) {
                        navIndex++;
                        moveCtrl();
                    } else {
                        navIndex = slider.count - button_num;
                    }
                    checkDirectionDisp(slider);
                }).end().find(".prev").on("click", function (e) {
                    e.preventDefault();
                    if (navIndex > 0) {
                        navIndex--;
                        moveCtrl();
                    } else {
                        navIndex = 0;
                    }
                    checkDirectionDisp(slider);
                });

                function moveCtrl() {
                    $ctrl_nav_ul.animate({ marginLeft: -navIndex * 25 + "%" }, { duration: 300, easing: "linear" });
                }

                function checkDirectionDisp(slider) {
                    if (navIndex == 0) {
                        $ctrl_dir.find(".prev").hide();
                    } else {
                        $ctrl_dir.find(".prev").show();
                    }

                    if (navIndex == li_num - button_num) {
                        $ctrl_dir.find(".next").hide();
                    } else {
                        $ctrl_dir.find(".next").show();
                    }
                }

                this.before = function (slider) {
                    var $ctrl_nav = $(".flex-control-nav", slider)
                    //                  , $li = $("li",$ctrl_nav).eq(slider.currentSlide)
                    ;

                    if (slider.animatingTo == 0) {
                        $("ul", $ctrl_nav).eq(0).stop().animate({ marginLeft: 0 }, { duration: 500, easing: "swing" });
                        navIndex = 0;
                    }

                    if (slider.animatingTo > button_num - 1) {
                        $("ul", $ctrl_nav).eq(0).stop().animate({ marginLeft: (button_num - 1 - slider.animatingTo) * 25 + "%" }, { duration: 500, easing: "swing" });
                    }

                    // index
                    if (slider.animatingTo - button_num >= 0) {
                        navIndex = slider.animatingTo - button_num + 1;
                    }

                    checkDirectionDisp(slider);
                };

                this.after = function (slider) {};

                //Callback: function(slider) - Fires when the slider loads the first slide
                checkDirectionDisp(slider);
            },

            //Callback: function(slider) - Fires asynchronously with each slider animation
            before: function before(slider) {},

            //Callback: function(slider) - Fires after each slider animation completes
            after: function after(slider) {},

            //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
            end: function end(slider) {}
        });

        // direction nav mouseover
        $(".flex-container").hover(function () {
            $(".flex-direction-nav", this).show();
        }, function () {
            $(".flex-direction-nav", this).hide();
        });

        // movie
        $("#movie-slide").flexslider({
            animation: "fade", //Select your animation type (fade/slide)
            slideshow: true, //Should the slider animate automatically by default? (true/false)
            slideshowSpeed: 10000, //Set the speed of the slideshow cycling, in milliseconds
            animationDuration: 400, //Set the speed of animations, in milliseconds
            directionNav: false, //Create navigation for previous/next navigation? (true/false)
            controlNav: true, //Create navigation for paging control of each clide? (true/false)
            keyboardNav: true, //Allow for keyboard navigation using left/right keys (true/false)
            touchSwipe: true, //Touch swipe gestures for left/right slide navigation (true/false)
            prevText: "Previous", //Set the text for the "previous" directionNav item
            nextText: "Next", //Set the text for the "next" directionNav item
            randomize: false, //Randomize slide order on page load? (true/false)
            slideToStart: 0, //The slide that the slider should start on. Array notation (0 = first slide)
            pauseOnAction: true, //Pause the slideshow when interacting with control elements, highly recommended. (true/false)
            pauseOnHover: true, //Pause the slideshow when hovering over slider, then resume when no longer hovering (true/false)
            controlsContainer: ".flex-container", //Advanced property: Can declare which container the navigation elements should be appended too. Default container is the flexSlider element. Example use would be ".flexslider-container", "#container", etc. If the given element is not found, the default action will be taken.
            manualControls: ".flex-control-nav li", //Selector: Declare custom control navigation. Example would be ".flex-control-nav li" or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.

            //Callback: function(slider) - Fires when the slider loads the first slide
            start: function start(slider) {
                //              this.after(slider);
            },

            //Callback: function(slider) - Fires asynchronously with each slider animation
            before: function before(slider) {},

            //Callback: function(slider) - Fires after each slider animation completes
            after: function after(slider) {},

            //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
            end: function end() {}
        });
    })();

    /*--------------------------------------------------------------------------*/
    /* Jump to the Top
    /*--------------------------------------------------------------------------*/

    ;(function () {
        var topLink = jQuery('#back-to-top');

        function jumpToTop(topLink) {
            if (jQuery(window).scrollTop() > 0) {
                topLink.show();
            } else {
                topLink.fadeOut(150);
            }
        }
        setTimeout(function () {
            jumpToTop(topLink);
        }, 50);
        jQuery(window).scroll(function () {
            jumpToTop(topLink);
        });

        topLink.find('a').click(function (e) {
            e.preventDefault();
            jQuery('html, body').stop().animate({ scrollTop: 0 }, 450);
        });
    })();

    /*--------------------------------------------------------------------------*/
    /* Anchor tag Scrolling
    /*--------------------------------------------------------------------------*/

    /*
        $("a[href^=#][href!=#]","#main-container").scrollAnchors();
    */

    /*--------------------------------------------------------------------------*/
    /* Print button
    /*--------------------------------------------------------------------------*/

    $("#print-page-preview-btn").on("click", function (e) {
        e.preventDefault();
        $("#print-css").attr("media", "screen,print");
        $("#print-preview").show();
        $("#print-page-preview-btn").hide();
    });

    $("#print-back-btn").on("click", function (e) {
        e.preventDefault();
        $("#print-css").attr("media", "print");
        $("#print-preview").hide();
        $("#print-page-preview-btn").show();
    });

    $("#print-this-page-btn").on("click", function (e) {
        e.preventDefault();
        print();
    });
}); //jQuery closure end

/*--------------------------------------------------------------------------*/
/* Retina
/*--------------------------------------------------------------------------*/
var isRetina = function isRetina() {
    var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)";
    if (window.devicePixelRatio > 1) {
        return true;
    }
    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
        return true;
    }
    return false;
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

/* カナメイ作成のtopicspath */
jQuery(document).ready(function () {
    //    get topicpath data
    (function () {
        var $breadcrumb = jQuery("#breadcrumb");
        var $breadcrumb_links = $breadcrumb.find(".breadcrumbset");

        $breadcrumb_links.each(function (index, elm) {
            var $breadcrumb_link = jQuery(elm);

            var vpath = $breadcrumb_link.attr("data-jpnic-vpath");
            if (!vpath) {
                return;
            }

            //デフォルトで最初のx-breadcrumb-configを見ます。
            var vpaths = [];
            var tmp = vpath.split("/");

            tmp.shift();
            var last = tmp.pop();
            if (last !== "") {
                tmp.push(last);
            }

            var vpathtemp = "/";
            jQuery.each(tmp, function (index, item) {
                vpathtemp += item + "/";
                vpaths.push(vpathtemp);
            });
            var $topicpath_a_tags = $breadcrumb_link.find("a");
            jQuery.each(vpaths, function (index, vpath) {
                //最後の１つは読み飛ばす。現在位置表示のためにある。ファイルは読まない。
                if (vpaths.length === index + 1) {
                    return;
                }
                if (index > $topicpath_a_tags.length - 2) {
                    return;
                }
                var nextVpath = null;
                if (vpaths.length > index + 1) {
                    nextVpath = vpaths[index + 1];
                }
                var localVpath = $topicpath_a_tags.eq(index).attr("data-jpnic-vpath");
                if (typeof localVpath !== "undefined") {
                    vpath = localVpath;
                }
                var datapath = "/common/topicpath" + vpath + "list.js";

                var d = jQuery.ajax({
                    url: datapath,
                    dataType: "json"
                });
                var depth = index + 1;
                d.done(function (data) {

                    var $blist = jQuery('<ul id="breadcrumb-depth-' + depth + '" class="breadcrumb-list" data-vpath = "' + vpath + '" data-breadcrumb-depth="' + depth + '"></ul>');
                    var $firstli = jQuery('<li/>');
                    var $subnuv = jQuery('<ul class="sub-nav"/>');

                    jQuery.each(data, function (index, item) {
                        var $a = jQuery("<a>" + item.text + "</a>").attr("href", item.href).attr("data-vpath", item.vpath);
                        var $li = jQuery("<li/>");
                        var re = new RegExp("^" + nextVpath);

                        if (nextVpath !== null && item.vpath.search(re) === 0 && typeof localVpath === "undefined") {
                            $a.addClass("jq_topicpath_now");
                            $firstli.append($a);
                        } else {
                            $subnuv.append($li.append($a));
                        }
                    });

                    $firstli.append($subnuv);
                    $blist.append($firstli);
                    $breadcrumb_link.append($blist);

                    //時間差で消す処理
                    var stId;
                    $blist.add($breadcrumb_link).on("mouseleave", function () {
                        stId = setTimeout(function () {
                            clearTimeout(stId);
                            $blist.hide();
                        }, 450);
                    }).on("mouseenter", function () {
                        clearTimeout(stId);
                    });
                    //ページのどこかをクリックで消す
                    var onTouchMoveFlag = false;
                    $(document).on("click touchstart", function (e) {
                        onTouchMoveFlag = false;
                    }).on("touchmove", function (e) {
                        onTouchMoveFlag = true;
                    }).on("touchend", function (e) {
                        if (onTouchMoveFlag) {
                            return;
                        }
                        if (e.target.parentNode.parentNode !== document.getElementById("breadcrumb")) {
                            $blist.hide();
                        }
                    });
                    $blist.on("click touchend", function (e) {
                        e.stopPropagation();
                    });
                });
            });
        });
    })();

    /* Breadcrumb ==================================================== */

    (function () {
        var $bc = $("#breadcrumb");
        var $bcLink = $bc.find(".breadcrumb-link").find("a");

        if ($bcLink.size() > 1) {
            $bcLink.eq(0).removeClass("back-to-site-top");
        }

        $bcLink.on("mouseover click", function (e) {
            var isTouch = function () {
                // タッチデバイス判定
                return document.ontouchstart !== undefined;
            }();
            if (isTouch) {
                //return ;
                e.preventDefault();
            }

            var $target = jQuery(e.target);
            var $bc = $target.closest(".breadcrumbset");
            var $bcLink = $bc.find(".breadcrumb-link").find("a");

            //一番最初のリンクは普通の動作　ここでは何もしない
            if ($bcLink.index(this) === 0) {
                return;
            }

            var $bcList = $bc.find(".breadcrumb-list");
            var $link = $(this);
            var $target_bcList = $bcList.filter("[data-breadcrumb-depth=" + $bcLink.index(this) + "]");
            //パンくずの階層に合わせたリストを選択
            //対応するリストが読み込まれていない場合も普通の動作
            if ($target_bcList.length === 0) {
                return;
            }

            //画面表示位置調整
            var xPos = $link.position().left;
            var xOffset = 15;
            var docWidth = $(window).width();
            var bcWidth = $target_bcList.outerWidth();

            if (xPos + bcWidth > docWidth - xOffset) {
                xPos = xPos - (xPos + bcWidth - docWidth) - xOffset;
            }

            $bcList.hide();
            $target_bcList.css({
                left: xPos
            }).show();
        });
    })();

    /*--------------------------------------------------------------------------*/
    /* menu
    /*--------------------------------------------------------------------------*/

    $("#menu").find(".menu-toggle").on("click", function (e, param1) {
        e.preventDefault();
        var $this = $(this);
        var $sub_ul = $this.parent().children("ul");

        $sub_ul.stop(true).slideToggle(function () {
            var flag = $sub_ul.is(":visible");
            if (flag) {
                $this.addClass("open");
                $sub_ul.css({ height: "auto" });
            } else {
                $this.removeClass("open");
                $sub_ul.css({ height: "auto" });
            }
        });
    });

    //menu open ==================================================== */
    (function () {
        var $breadcrumbs = jQuery("#breadcrumb").find(".breadcrumbset");
        $breadcrumbs.each(function (index, elm) {
            var $breadcrumb = jQuery(elm);
            var vpath = $breadcrumb.attr("data-jpnic-vpath");
            if (!vpath) {
                return;
            }
            var texts = vpath.split("/");
            var last = texts.pop;
            if (last === "") {
                last = texts.pop;
            }
            var $menu = jQuery("#menu");
            var baseVpath = $menu.attr("data-jpnic-vpath");
            var baseVpathDepth = baseVpath.split("/").length - 2;
            var vpathDepth1Texts = [];
            for (var i = 0; i < baseVpathDepth + 2; i++) {
                vpathDepth1Texts.push(texts[i]);
            }
            vpathDepth1Texts.push("");
            var vpathDepth1 = vpathDepth1Texts.join("/");
            $('.main-nav > li[data-jpnic-vpath="' + vpathDepth1 + '"] .menu-toggle', $menu).addClass("open").parent().children("ul").show();
        });
    })();
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js